var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider",class:{ '__border-top': _vm.borderTop },style:({ height: _vm.dividerHeight })})}
var staticRenderFns = []

export { render, staticRenderFns }